const setFooterMargin = () => {
  const footerElement = document.querySelector('.footer-styling');
  if (footerElement) {
    footerElement.style.marginTop = '0';
  }
};

// Function to randomize badge section and display on page load
const badgesRandomSelection = () => {
  // Getting the array of badge items
  const badgesArray = document.querySelectorAll('.fyle-recognition-badges .fyle-badge');
  
  if (badgesArray.length === 0) {
    return;
  }
  
  // Getting a random index of element to display
  const displayItemIndex = Math.floor(Math.random() * badgesArray.length);
  
  badgesArray.forEach((badge, i) => {
    // Display the badge item with random index
    if (i === displayItemIndex) {
      // Add background class to g2-100 badge section if it is selected else remove it
      const badgeContainer = badge.closest('.fyle-recognition-badges');
      const g2TopBadge = 'g2-top-100-badge-section';
      
      if (i === 0 && badgeContainer) {
        badgeContainer.classList.add(g2TopBadge);
      } else if (badgeContainer) {
        badgeContainer.classList.remove(g2TopBadge);
      }

      badge.style.display = 'block';
      // Hide other badge items
    } else {
      badge.style.display = 'none';
    }
  });
};

const setExpenseFeatureActive = () => {
  // Add default hover state to the expense feature card
  const expenseFeatures = document.querySelectorAll('.expense-feature');
  expenseFeatures.forEach((feature) => feature.classList.add('hover-state'));
  
  const containerWrappers = document.querySelectorAll('.container-wrapper');
  containerWrappers.forEach((wrapper) => {
    wrapper.addEventListener('mouseover', (event) => {
      event.currentTarget.classList.remove('hover-state');
      containerWrappers.forEach((w) => w.classList.remove('hover-state'));
    });
  });
};

const setCardsActive = (cardElements) => {
  Array.from(cardElements).forEach((cardElement) => {
    cardElement.classList.add('hover-state');
  });

  const cardColumns = document.querySelectorAll('.card-column');
  cardColumns.forEach((cardColumn) => {
    cardColumn.addEventListener('mouseover', (event) => {
      event.currentTarget.classList.remove('hover-state');
      Array.from(cardElements).forEach((cardElement) => {
        cardElement.classList.remove('hover-state');
      });
    });
  });
};

const initHelloBar = () => {
  const helloBarLink = document.querySelector('.hello-bar-link');
  if (helloBarLink) {
    helloBarLink.addEventListener('click', () => {
      localStorage.setItem('helloBar', true);
    });
  }

  if (!localStorage.getItem('helloBar')) {
    const helloBar = document.querySelector('.hello-bar');
    if (helloBar) {
      helloBar.style.display = 'block';
      if (window.pageYOffset < 10) {
        const navbar = document.querySelector('.navbar');
        const navbarMobile = document.querySelector('.navbar-mobile');
        if (navbar) {
          navbar.classList.add('hello-bar-at-top');
        }
        if (navbarMobile) {
          navbarMobile.classList.add('hello-bar-at-top');
        }
      }
    }
  }
};

//Timeline scroll animation
const companyTimelineAnimation = () => {
  const halfOfScreen = window.innerHeight / 2;
  const timeLineBackground = document.querySelector('.time-line-background');
  const indicatorIcons = document.querySelectorAll('.stem-icon');
  
  if (!timeLineBackground || indicatorIcons.length === 0) {
    return;
  }
  
  const timeLineHandler = () => {
    const bottomPoint = timeLineBackground.getBoundingClientRect().top + window.pageYOffset;
    const halfOfScreenInDocument = window.pageYOffset + halfOfScreen;
    const spaceToReachMiddle = halfOfScreenInDocument - bottomPoint;
    
    if (bottomPoint <= halfOfScreenInDocument && spaceToReachMiddle > 50 && spaceToReachMiddle <= 500) {
      timeLineBackground.style.height = `${spaceToReachMiddle}px`;
    }
    
    indicatorIcons.forEach((icon, i) => {
      const iconTop = icon.getBoundingClientRect().top;
      if (iconTop <= halfOfScreen) {
        icon.classList.add('blue-bg');
      } else {
        if (i !== 0) {
          icon.classList.remove('blue-bg');
        }
      }
    });
  };

  window.addEventListener('scroll', timeLineHandler);
};

export {
  setFooterMargin,
  badgesRandomSelection,
  setExpenseFeatureActive,
  setCardsActive,
  initHelloBar,
  companyTimelineAnimation,
};